import { api } from './client'

/** C-15 - client di `HomeController` (`/api/home`): pagina iniziale per ruolo, dietro il flag `home.per_ruolo`. */
export interface HomeTileDto {
  key: string
  label: string
  hint: string
  value: number
  /** Solo nei tile con importo e solo con CanSeeRealAmounts. */
  amount?: number | null
  anomaly: boolean
  route: string
  drillDown: string
}

export interface HomeSection {
  key: string
  title: string
  tiles: HomeTileDto[]
}

export interface HomeResponse {
  profile: 'agente' | 'backoffice' | 'amministrazione' | 'direzione'
  sections: HomeSection[]
}

export interface HomeDrillItem {
  id: number
  title: string
  route: string
  amount?: number | null
}

export interface HomeDrillResponse {
  key: string
  label: string
  total: number
  amount?: number | null
  page: number
  pageSize: number
  route: string
  items: HomeDrillItem[]
}

export const homeApi = {
  get: () => api<HomeResponse>('/api/home'),
  tile: (key: string, page = 1) => api<HomeDrillResponse>(`/api/home/tiles/${encodeURIComponent(key)}?page=${page}&pageSize=50`),
}
